import React, { useState } from 'react';
import './salaryHeader.css';
import { useDispatch, useSelector } from "react-redux";
import { setSalariesDataAction } from "../../../redux/rootReducer";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";
import { getSalariesDataSagaAction } from "../../../redux/sagaActions";

const SalaryHeader = () => {
    const dispatch = useDispatch();
    const salaries_data = useSelector(state => state.salaries_data);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    return (
        <>
            <div className="salary__period">
                <div className="flt__box">
                    <div className="flt__title">Начало периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >{ salaries_data.date_from ? new Date(salaries_data.date_from).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ salaries_data.date_from }
                        handler={ date => {
                            dispatch(setSalariesDataAction({
                                ...salaries_data,
                                date_from: date
                            }));
                            setOpenFromCalendar(false);
                        } }
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="flt__title">Окончание периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >{ salaries_data.date_to ? new Date(salaries_data.date_to).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ salaries_data.date_to }
                        handler={ date => {
                            dispatch(setSalariesDataAction({
                                ...salaries_data,
                                date_to: date
                            }));
                            setOpenToCalendar(false);
                        } }
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="button button--blue"
                         onClick={ () => dispatch(getSalariesDataSagaAction({
                             date_from: salaries_data.date_from,
                             date_to: salaries_data.date_to,
                             coach_workout_cost: salaries_data.coach_workout_cost,
                             coach_client_cost: salaries_data.coach_client_cost,
                             workouts_types_cost: JSON.stringify(salaries_data.workouts_types_cost),
                             consider_subscription_cost: salaries_data.consider_subscription_cost,
                             consider_subscription_percent: salaries_data.consider_subscription_percent,
                             one_time_percent: salaries_data.one_time_percent
                         })) }
                    >Применить</div>
                </div>
            </div>
        </>
    );
};

export default SalaryHeader;